module.exports = __webpack_public_path__ + "img/thoodo.ca8cac1c.jpg";